const tableTitleMap = {
  title: 'Map'
}

export default tableTitleMap;
